export default {
    root: ({props}) => ({
        class: [
            // Sizing and Shape
            "min-w-[12rem] max-w-3xl",
            "rounded-md",
            // Spacing
            // "py-2",
            // Colors
            "bg-stone-50 dark:bg-stone-800",
            "text-stone-700 dark:text-white/80",
            {
                "border border-stone-200 dark:border-stone-700 shadow-xl shadow-stone-600 dark:shadow-stone-900 overflow-hidden":
                    props.popup,
            },
        ],
    }),
    list: {
        class: [
            // Spacings and Shape
            "list-none",
            "m-0",
            "p-0",
            "outline-none",
        ],
    },
    separator: {
        class: "border-t border-stone-200 dark:border-stone-600",
    },
    itemContent: ({context}) => {
        return {
            class: [
                //Shape
                "rounded-none",
                // Colors
                "",
                {
                    "bg-stone-200 text-stone-700 dark:bg-stone-900 dark:text-white":
                        context.focused && !context.item.class,
                },
                // Transitions
                "transition",
                "duration-200",
                // States
                {
                    "hover:bg-stone-100 dark:bg-stone-700 dark:hover:bg-stone-900 hover:text-stone-700 dark:hover:text-white/80 text-stone-700 dark:text-white/80":
                        !context.item.class,
                },
            ],
        };
    },
    itemLink: {
        class: [
            "relative",
            // Flexbox

            "flex",
            "items-center",

            // Spacing
            "py-3",
            "px-5",

            // Color
            "text--stone-700 dark:text--white/80",

            // Misc
            "no-underline",
            "overflow-hidden",
            "cursor-pointer",
            "select-none",
        ],
    },
    itemIcon: {
        class: [
            // Spacing
            "mr-2",

            // Color
            "text--stone-600 dark:text--white/70",
        ],
    },
    itemLabel: {
        class: ["leading-none"],
    },
    submenuLabel: {
        class: [
            // Font
            "font-bold",
            // Spacing
            "m-0",
            "py-3 px-5",
            // Shape
            // "rounded-tl-none",
            // "rounded-tr-none",
            // Colors
            "bg-stone-50 dark:bg-stone-700",
            "text-stone-700 dark:text-white",
        ],
    },
    transition: {
        enterFromClass: "opacity-0 scale-y-[0.8]",
        enterActiveClass: "transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]",
        leaveActiveClass: "transition-opacity duration-100 ease-linear",
        leaveToClass: "opacity-0",
    },
};
